module.exports = __webpack_public_path__ + "2504c6925b2ae4bfb31815922adc1e67.svg";